<template>
  <section>
    <TillFondCaisse
      v-bind.sync="newFCaisse"
      :current="currentCaisse"
      :default="defaultFCaisse"
    ></TillFondCaisse>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Total du fond de caisse"
          :value="newFondCaisseString"
          readonly
          class="no-before"
        >
          <template slot="prepend-inner">
            <v-icon left>
              fa-cash-register
            </v-icon>
          </template>
          <template slot="append">
            <v-row align="center" justify="end" no-gutters>
              <v-chip
                label
                :color="
                  newFCaisse.total !== defaultFCaisse.total ? '#E57373' : null
                "
                >{{ `Cible ${defaultFCaisse.total}$` }}</v-chip
              >
            </v-row>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Montant du dépôt"
          :value="depositString"
          readonly
          class="no-before"
        >
          <template slot="prepend-inner">
            <v-icon left>fa-envelope</v-icon>
          </template>
          <template slot="append">
            <v-row align="center" justify="end" no-gutters>
              <v-chip label
                ><v-avatar>
                  <v-icon>monetization_on</v-icon>
                </v-avatar>
                {{ `${depositBillNumber} x 20$` }}</v-chip
              >
            </v-row>
          </template>
        </v-text-field></v-col
      >
    </v-row>
    <v-row align="center" dense>
      <v-col cols="12">
        <v-btn color="success" block @click="saveTill"
          ><v-icon small left>fa-save</v-icon>Soumettre le balancement</v-btn
        >
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { api } from "@/api";
import TillFondCaisse from "./TillFondCaisse";
export default {
  name: "TillAfter",
  components: {
    TillFondCaisse
  },
  props: {
    currentCaisse: {
      required: true
    },
    tillId: {
      required: true
    }
  },
  async created() {
    await this.getDefaultCaisse();
  },
  computed: {
    deposit() {
      return (this.currentCaisse.argent_20dollar -
        this.newFCaisse.argent_20dollar) *
        20 >
        0
        ? (this.currentCaisse.argent_20dollar -
            this.newFCaisse.argent_20dollar) *
            20
        : 0;
    },
    depositString() {
      return `${this.deposit} $`;
    },
    depositBillNumber() {
      return this.currentCaisse.argent_20dollar -
        this.newFCaisse.argent_20dollar >
        0
        ? this.currentCaisse.argent_20dollar - this.newFCaisse.argent_20dollar
        : 0;
    },
    newFondCaisseString() {
      return `${this.newFCaisse.total} $`;
    }
  },
  data() {
    return {
      showInfo: false,
      loading: false,
      saving: false,
      saved: {
        fcaisse: false,
        deposit: false
      },
      defaultFCaisse: {
        argent_5cent: 20,
        argent_10cent: 50,
        argent_25cent: 60,
        argent_1dollar: 41,
        argent_2dollar: 24,
        argent_5dollar: 10,
        argent_10dollar: 8,
        argent_20dollar: 1,
        argent_50dollar: 0,
        argent_100dollar: 0,
        rouleaux_5cent: 1,
        rouleaux_10cent: 1,
        rouleaux_25cent: 1,
        rouleaux_1dollar: 1,
        rouleaux_2dollar: 1,
        total: 352
      },
      newFCaisse: {
        argent_5cent: 0,
        argent_10cent: 0,
        argent_25cent: 0,
        argent_1dollar: 0,
        argent_2dollar: 0,
        argent_5dollar: 0,
        argent_10dollar: 0,
        argent_20dollar: 0,
        argent_50dollar: 0,
        argent_100dollar: 0,
        rouleaux_5cent: 0,
        rouleaux_10cent: 0,
        rouleaux_25cent: 0,
        rouleaux_1dollar: 0,
        rouleaux_2dollar: 0,
        total: 0
      }
    };
  },
  methods: {
    async getDefaultCaisse() {
      try {
        this.loading = true;
        const res = await api.getDefaultFondCaisse();
        if (res && res !== "") {
          const d = {
            ...res,
            total: this.calculateTotal()
          };
          this.defaultFCaisse = d;
        }
        this.newFCaisse = Object.assign({}, this.defaultFCaisse);
      } finally {
        this.loading = false;
      }
    },
    calculateTotal() {
      const total =
        this.defaultFCaisse.argent_5cent * 0.05 +
        this.defaultFCaisse.argent_10cent * 0.1 +
        this.defaultFCaisse.argent_25cent * 0.25 +
        this.defaultFCaisse.argent_1dollar * 1 +
        this.defaultFCaisse.argent_2dollar * 2 +
        this.defaultFCaisse.argent_5dollar * 5 +
        this.defaultFCaisse.argent_10dollar * 10 +
        this.defaultFCaisse.argent_20dollar * 20 +
        this.defaultFCaisse.argent_50dollar * 50 +
        this.defaultFCaisse.argent_100dollar * 100 +
        this.defaultFCaisse.rouleaux_5cent * 2 +
        this.defaultFCaisse.rouleaux_10cent * 5 +
        this.defaultFCaisse.rouleaux_25cent * 10 +
        this.defaultFCaisse.rouleaux_1dollar * 25 +
        this.defaultFCaisse.rouleaux_2dollar * 50;
      return total;
    },
    getNewFondCaisse() {
      return this.newFCaisse;
    },
    getDepositValue() {
      return this.deposit;
    },
    saveTill() {
      this.$emit("save");
    }
  }
};
</script>

<style lang="scss" scoped>
.card-title-icon-header {
  font-size: 1.5rem;
  color: $primary;
}

@media screen and (max-width: 720px) {
  button.v-btn {
    width: 95%;
  }
}
</style>
